import { Component } from 'react';
import { connect } from 'react-redux';
import DateTime from 'react-datetime';
import { FormControl, FormGroup, Card, Row, Col, Button } from 'react-bootstrap';

class PipEposSubmissionsSearch extends Component {
  render() {
    const {
      search,
      weekOfSaleFrom,
      weekOfSaleTo,
      status,
      objectiveId,
      meta,
      onHandleSearchChange,
      onHandleWeekOfSaleFromChange,
      onHandleWeekOfSaleToChange,
      onHandleStatusChange,
      onHandleObjectiveChange,
      onHandleSearch,
      onHandleClear
    } = this.props;

    return (
      <div>
        <Card className="submission-filter admin-search-filter">
          <Card.Body>
            <Row>
              <Col md={3}>
                <FormGroup>
                  Search
                  <FormControl
                    value={search}
                    onChange={onHandleSearchChange}
                    placeholder={'Enter Epos Submission Id or Outlet Id'}
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  Week of Sale from
                  <DateTime
                    timeFormat={false}
                    dateFormat="DD/MM/YYYY"
                    value={weekOfSaleFrom}
                    onChange={onHandleWeekOfSaleFromChange}
                    inputProps={
                      { placeholder: 'Week of Sale from' }
                    }
                  />
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  Week of Sale to
                  <DateTime
                    timeFormat={false}
                    dateFormat="DD/MM/YYYY"
                    value={weekOfSaleTo}
                    onChange={onHandleWeekOfSaleToChange}
                    inputProps={
                      { placeholder: 'Week of Sale to' }
                    }
                  />
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={3}>
                <FormGroup>
                  Status
                  <FormControl
                    value={status}
                    onChange={onHandleStatusChange}
                    as="select"
                  >
                    <option>ALL</option>
                    {meta.statuses && meta.statuses.map((statusOption, index) => (<option key={index}>{statusOption}</option>))}
                  </FormControl>
                </FormGroup>
              </Col>
              <Col md={3}>
                <FormGroup>
                  Objective name
                  <FormControl
                    value={objectiveId}
                    as="select"
                    onChange={onHandleObjectiveChange}
                  >
                    <option>ALL</option>
                    {meta.objectives &&
                      meta.objectives.map(({ label, value }) => (<option key={value} value={value}>{label}</option>))}
                  </FormControl>
                </FormGroup>
              </Col>
            </Row>
            <Row>
              <Col md={6} className="actions">
                <Button
                  className="red-ghost-btn"
                  onClick={onHandleSearch}
                >
                  Search
                </Button>
                <Button
                  className="red-ghost-btn"
                  onClick={onHandleClear}
                >
                  Clear
                </Button>
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  meta: state.pipEposSubmissions.meta,
});

export default connect(mapStateToProps)(PipEposSubmissionsSearch);
